module.exports = __webpack_public_path__ + "static/media/100x800_PT01.7a094ae5.gif";